<template>
  <form id="woodInfo">
    <div class="tab">
      <input class="tab-input" id="form-summit" type="checkbox" name="tabs" />
      <label class="tab-label" for="form-summit">Angaben zum Polter</label>
      <div class="tab-content" style="background-color: #f6f6f6; padding:0em 1em;">
        <div class="field" style="padding-top:2em;">
          <label class="label" for="woodLocation">
            Lagerort
            <span
              style="font-weight: 350; font-size: 12px;margin-left: 0.5em;"
            >gerne auch als GPS-Koordinate (lat/lon)</span>
          </label>
          <div class="control">
            <input class="input" v-model="woodInfo.location" type="text" name="woodLocation" placeholder="Lagerort" />
          </div>
        </div>

        <div class="field">
          <label class="label" for="woodCuttingTime">Hiebszeit ca. von - bis:</label>
          <div class="control">
            <input class="input" v-model="woodInfo.cuttingTime" name="woodCuttingTime" type="text" placeholder="Hiebszeit" />
          </div>
        </div>

        <div class="field">
          <label class="label" for="woodAmountStacks">Anzahl Polter</label>
          <div class="control">
            <input v-model.number="woodInfo.amountOfStacks" class="input" name="woodAmountStacks" type="number" value="1" />
          </div>
        </div>

        <div class="field" style="padding-bottom: 1em;">
          <label class="label" for="woodNotes">Bemerkungen</label>
          <div class="control">
            <textarea
            v-model="woodInfo.notes"
              class="textarea"
              name="woodNotes"
              rows="3"
              type="text"
              maxlength="340"
              placeholder="Bemerkungen"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: "timber-info-form",
  props: {
    woodInfo: {
      location: String,
      cuttingTime: String,
      amountOfStacks: Number,
      notes: String
    }
  },
  computed: {}
};
</script>

<style scoped>
</style>